import { Title } from "react-admin";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Typography,
} from "@mui/material"
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";

const ExcelConnectorDownload = () => {
  return (
    <Card>
      <Title title="Excel Connector Download" />
      <CardContent>
        <Typography sx={{ fontSize: 14 }} color="textSecondary" gutterBottom>
          InfoBate Excel Connector
        </Typography>

        <Box>
          <Button startIcon={<CloudDownloadIcon />} variant="contained" color="primary" href="/excel_aws_api.xlsm" style={{ float: "left" }}>Download</Button>
        </Box>

        <Box style={{ display: "flex", justifyContent: "space-around", marginBottom: 300 }}>
          <Box>
            <CardMedia
              sx={{
                height: 150 * 2,
                width: 175 * 2,
                backgroundRepeat: "no-repeat",
                backgroundSize: "100% 100%",
              }}
              image="excel_api_login.png"
              title="Login"
            ></CardMedia>

            <Typography color="textSecondary" component="p" style={{ maxWidth: 300 }}>
              Login before viewing resources.
            </Typography>
          </Box>
          <Box>
            <CardMedia
              sx={{
                height: 150 * 2,
                width: 195 * 2,
                backgroundRepeat: "no-repeat",
                backgroundSize: "100% 100%",
              }}
              image="excel_api_resources.png"
              title="Login"
            ></CardMedia>

            <Typography color="textSecondary" component="p" style={{ maxWidth: 300 }}>
              Click the resources button to view the available data.
            </Typography>
          </Box>
        </Box>

        <Typography variant="body2" component="p">
          *A proof of concept showing Excel access using the same API's that this site uses.
        </Typography>
      </CardContent>
    </Card>
  )
};

export default ExcelConnectorDownload;
